export const leadConstants = {
  LEAD_LOAD: '[Lead] Load',
  LEAD_LOAD_SUCCESS: '[Lead] Load success',
  LEAD_LOAD_FAILURE: '[Lead] Load failure',
  LEAD_RESET: '[Lead] Reset',
  LEAD_SAVE: '[Lead] Save',
  LEAD_SAVE_SUCCESS: '[Lead] Save success',
  LEAD_SAVE_FAILURE: '[Lead] Save failure',
  LEAD_PATCH: '[Lead] Patch',
  LEAD_PATCH_SUCCESS: '[Lead] Patch success',
  LEAD_PATCH_FAILURE: '[Lead] Patch failure'
}
